<script setup lang="ts">
import { ref, type HTMLAttributes, watchEffect } from "vue";
import { useMyInfoStore } from "~/stores/MyInfoStore";

const props = defineProps<{
  id: HTMLAttributes["id"];
  isDragging?: boolean;
}>();

const emit = defineEmits<(e: "drop", event: DragEvent) => void>();
/** True if there is a draggable item hovering on top of this component. */
const dragHovering = ref<boolean>(false);

const myInfoStore = useMyInfoStore();
const hasSetupBasicRole = myInfoStore.hasSetupBasicRole;
const handleDrop = (event: DragEvent) => {
  if (!hasSetupBasicRole) {
    event.preventDefault();
    return;
  }

  event.preventDefault();
  dragHovering.value = false;
  emit("drop", event);
};

const handleDragEnter = (event: DragEvent) => {
  if (!hasSetupBasicRole) {
    event.preventDefault();
    return;
  }

  event.preventDefault();
  dragHovering.value = true;
};

const handleDragLeave = (event: DragEvent) => {
  dragHovering.value = false;
  event.preventDefault();
};

watchEffect(() => {
  if (!props.isDragging) {
    dragHovering.value = false;
  }
});
</script>

<template>
  <slot />
  <div
    class="droppable-pad"
    :class="{ dragging: dragHovering && hasSetupBasicRole }"
    @drop="handleDrop"
    @dragover.prevent
    @dragenter.prevent
    @dragleave="handleDragLeave"
    @dragenter="handleDragEnter"
  >
    <div
      v-if="dragHovering && hasSetupBasicRole"
      :id="id"
      class="droppable-pad-area ready"
    >
      Drop to Insert
    </div>
    <div
      v-if="props.isDragging && !dragHovering && hasSetupBasicRole"
      class="droppable-pad-area"
    >
      Insert Here
    </div>
  </div>
</template>

<style scoped lang="less">
.droppable-pad {
  width: 100%;
  position: absolute;
  bottom: 0;
  margin: 0 auto;
  height: 0;
  &.dragging {
    border-top: 1px solid var(--el-color-success);
  }
}
.droppable-pad-area {
  position: absolute;
  left: 25%;
  right: 25%;
  bottom: -15px;
  height: 25px;
  display: flex;
  z-index: 10000;
  background-color: white;
  border: 2px dashed var(--el-color-primary);
  border-radius: 5px;
  // transition: all 0.2s ease-in-out;
  //margin: 1px auto;
  padding: 4px 0;
  opacity: 0.85;
  justify-content: center;
  align-items: center;

  &.ready {
    opacity: 1;
    height: auto;
    border-color: var(--el-color-success);
    background-color: var(--el-color-success-light-8);
  }
}
</style>
